function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "git",
  d: "M229,124.2c-19.4,7.8-40.3,13.5-61.5,13.5c-60.7-35.4-143.1,1.5-143.1,79.1h0c0,28.9,18.3,68.6,46.8,78.3v1.2 c-21.2,9.5-27.1,57.8,1.1,75.2v1.2c-30.8,10.3-51.1,30-51.1,64.2c0,58.9,55,75.2,103.2,75.2c58.7,0,102.3-21.4,102.3-86.9 c0-80.6-113.9-50.9-113.9-94.6c0-15.4,8.1-21.4,22.2-24.3c62.3-11.7,87.7-74,71.6-117.9c7.6-1.7,14.9-3.8,22.2-6.3V124.2z  M123.4,404L123.4,404c19.2,0,46.5,3.4,46.5,28.5c0,24.9-22,30.1-42.5,30.1c-19.5,0-48.9-3.1-48.9-28.8 C78.6,408.4,103.4,404,123.4,404L123.4,404z M119.8,256L119.8,256c-24.8,0-35.3-14.9-35.3-38.6c0-56.3,68.8-55.8,68.8-0.6 C153.3,240,144.3,256,119.8,256L119.8,256z"
}), /*#__PURE__*/React.createElement("path", {
  className: "git",
  d: "M490.7,368.6v-56c-9,6.3-22,9.5-33,9.5c-20.9,0-24.6-20.6-24.6-37.5V180.5c35.8,0,57.6,1.2,57.6,1.2v-54.3H433 c0-15.7-0.6-31.3,1.7-47.1h-64c2,11.6,1.7,21.6,1.7,47.1h-27.1v54.3c18.8-3,19.2-1.2,27.1-1.2v1.2h-0.6v100.2 c0,49.7,7.1,97.9,67.5,97.9C456.3,379.8,475.7,376.9,490.7,368.6L490.7,368.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "git",
  d: "M287.8,0c-22.5,0-38.9,19.9-38.9,41.9c0,21.7,16.6,41.4,38.9,41.4c21.8,0,38.1-20,38.1-41.4 C326,20.6,310.1,0,287.8,0z"
}), /*#__PURE__*/React.createElement("path", {
  className: "git",
  d: "M256.3,127.1c2,16.9,1.8,228.2,0,248.9H319c-1.8-20.5-2-232.2,0-248.9H256.3z"
}));

function SvgGit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.bbec3803.svg";
export { ForwardRef as ReactComponent };